import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { useSession } from './lib/session';
import { CountriesPage } from './pages/Countries';
import { DashboardPage } from './pages/Dashboard';
import { LoginPage } from './pages/Login';
import { NotificationsPage } from './pages/Notifications';
import { SharedIpsPage } from './pages/SharedIps';
import { UsersPage } from './pages/Users';

export function App() {
  const session = useSession();

  if (session.isPending) {
    return (
      <div className="grid min-h-dvh place-items-center bg-canvas">
        <Spinner className="size-6" />
      </div>
    );
  }

  // No redirect on sign-out: rendering the login screen in place keeps the
  // requested URL intact, so a deep link survives a login.
  if (!session.data) return <LoginPage />;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout session={session.data} />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="shared-ips" element={<SharedIpsPage />} />
          <Route path="countries" element={<CountriesPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="*" element={<DashboardPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
